export const CALENDAR_PROVIDERS = {
  googleCalendar: {
    type: 'googleCalendar',
    name: 'Google Calendar',
    logo: '/assets/meeting-provider/google-calendar-logo.svg',
    logoShort: '/assets/meeting-provider/google-calendar-logo-short.svg',
    description:
      'Synchronize your Google Calendar with ExoPaper and keep track of all your appointments. Thanks to the seamless integration, you can automatically include your meetings and events in other programs such as Outlook or the native calendar apps from Android and Apple - for optimal planning without duplicate entries.',
  },
  microsoftCalendar: {
    type: 'microsoftCalendar',
    name: 'Microsoft 365',
    logo: '/assets/meeting-provider/microsoft-365-logo.svg',
    logoShort: '/assets/meeting-provider/microsoft-365-logo.svg',
    description:
      'Synchronize your Microsoft 365 Calendar with ExoPaper and keep track of all your appointments. Thanks to the seamless integration, you can manage your meetings and events alongside other calendar providers - for optimal planning without duplicate entries.',
  },
};
